import moment from "moment";
import "moment/locale/sv";
import React, { Component } from "react";
import { connect } from "react-redux";
import { List } from "material-ui/List";
import Divider from "material-ui/Divider";
import Subheader from "material-ui/Subheader";
import CircularProgress from "material-ui/CircularProgress";
import * as scheduleActions from "../store/schedule/scheduleActions";
import * as scheduleSelectors from "../store/schedule/scheduleSelectors";
import * as globalStyles from "../constants/styles";
import Match from "./Match";

class Schedule extends Component {
  componentDidMount() {
    const { fetchSchedule } = this.props;
    fetchSchedule();
  }

  render() {
    const { schedule } = this.props;
    if (!schedule) {
      return (
        <div style={styles.loader}>
          <CircularProgress />
        </div>
      );
    }
    return (
      <List>
        {schedule.rounds.map((round, index) => (
          <div key={`round-${index}`}>
            <Subheader>
              Runda {round.round},{" "}
              {moment
                .utc(round.date)
                .local()
                .locale("sv")
                .format("dddd Do MMMM, [kl.] HH:mm")}
            </Subheader>
            {round.matches.map(matchId => (
              <Match key={`match-${matchId}`} matchId={matchId} />
            ))}
            <Divider />
          </div>
        ))}
      </List>
    );
  }
}

const styles = {
  listItem: {
    cursor: "default"
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    padding: globalStyles.space * 2
  }
};

const mapStateToProps = (state, initialProps) => {
  const { division } = initialProps;
  return {
    schedule: scheduleSelectors.getSchedule(state, division)
  };
};

const mapDispatchToProps = (dispatch, initialProps) => {
  const { division } = initialProps;
  return {
    fetchSchedule: () => dispatch(scheduleActions.fetchSchedule(division))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Schedule);



// WEBPACK FOOTER //
// ./src/components/Schedule.js